import React, { useState } from "react"

import { useForm } from "react-hook-form"

import { FRONT_VALIDATION_CONFIG } from "@front-shared/config/validation.config"
import { ButtonElement } from "@front-shared/elements/button.element"
import { InputElement } from "@front-shared/elements/input.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

export const IntakeDemoFailureComponent: React.FunctionComponent = () => {
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm()

    const [followUpPhoneNumber, setFollowUpPhoneNumber] = useState<string>()

    const onPhoneNumberSubmit = (data: any) => {
        setFollowUpPhoneNumber(data.phoneNumber)
    }

    return (
        <div className="relative">
            <PrimaryText typography="h3">
                Unfortunately, we <br /> couldn’t verify your <br /> plan.
            </PrimaryText>

            {followUpPhoneNumber ? (
                <>
                    <PrimaryText className="mt-[24px]">Thanks.</PrimaryText>

                    <PrimaryText className="mt-[24px]">
                        Someone from our team will text you at{" "}
                        <span className="text-bold">{followUpPhoneNumber}</span>{" "}
                        in the next 24 hours.
                    </PrimaryText>
                </>
            ) : (
                <>
                    <PrimaryText className="mt-[24px]">
                        A request has been automatically sent to our team. We
                        can send you a text to follow up and confirm your
                        eligibility.
                    </PrimaryText>

                    <form onSubmit={handleSubmit(onPhoneNumberSubmit)}>
                        <InputElement
                            className="mt-[44px]"
                            label="Your phone number"
                            name="phoneNumber"
                            mask="000-000-0000"
                            placeholder="123-123-1234"
                            maskOptions={{
                                lazy: true,
                            }}
                            reactHookControl={control}
                            reactHookValidations={{
                                required: FRONT_VALIDATION_CONFIG.required,
                                pattern: FRONT_VALIDATION_CONFIG.usPhoneNumber,
                            }}
                            reactHookErrors={errors}
                        />

                        <div className="fixed z-10 left-0 bottom-0 p-[24px] w-full bg-brand-offWhite">
                            <ButtonElement
                                label="Send me a text follow-up"
                                type="primary"
                                size="large"
                                htmlType="submit"
                                buttonClassName="w-full"
                            />
                        </div>
                    </form>
                </>
            )}
        </div>
    )
}
